<template>
  <div class="yhc-service-level-date-mode-switch">
    <div class="yhc-service-level-date-mode-switch__title">発着日選択</div>
    <b-form-radio-group
      v-model="currentMode"
      class="yhc-service-level-date-mode-switch__radios"
      buttons
      button-variant="outline-primary"
      size="sm"
    >
      <b-form-radio value="pickup">お預かり日</b-form-radio>
      <b-form-radio value="delivery">お届け日</b-form-radio>
    </b-form-radio-group>
  </div>
</template>

<script lang="ts">
import { YhcEstimateFormFrontService } from '../../YhcEstimateFormFrontPage/YhcEstimateFormFrontService'

export default {
  name: 'YhcServiceLevelDateModeSwitch',
  inject: ['YhcEstimateFormFrontServiceInstance'],
  computed: {
    $yhcefs(): YhcEstimateFormFrontService {
      return this.YhcEstimateFormFrontServiceInstance
    },
    currentMode: {
      get(): 'pickup' | 'delivery' {
        return this.$yhcefs.$userInputData.serviceLevelDateMode
      },
      set(value: 'pickup' | 'delivery') {
        this.$yhcefs.$userInputData.serviceLevelDateMode = value
        void this.$yhcefs.$userInputData.refreshMastersForSelectedDates()
      },
    },
  },
}
</script>

<style lang="scss" scoped>
.yhc-service-level-date-mode-switch {
  padding: 8px 16px;
  background-color: #fff;
  border-radius: 6px;
  box-shadow: 1px 1px 8px rgba(0, 0, 0, 0.15);
  box-sizing: border-box;

  &__title {
    font-size: 18px;
    font-weight: 600;
    margin-bottom: 8px;
    color: var(--yhc-color);
  }

  &__radios {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
  }

  @media screen and (max-width: 767px) {
    padding: 6px 10px;
    width: 100%;

    &__title {
      font-size: 16px;
    }
  }
}
</style>
